import { cloneDeep } from 'lodash-es';
import { modelManager } from '../manager/entityManager';
import { globalStores, TGlobalStores } from '../stores';
import { getUniqueId } from '../utils';
import { EEntityType, EFaceSide, EOperateMode, EToolType } from '../types';
import { EColumnType, IColumnData } from '../data/model/model';
import { EOperationType } from '../types/operation';

export class StructOperation {
  private structStore: TGlobalStores['structStore'];
  private faceStore: TGlobalStores['faceStore'];
  private history: TGlobalStores['history'];
  private editorStateStore: TGlobalStores['editorStateStore'];

  constructor(gs: TGlobalStores) {
    this.structStore = gs.structStore;
    this.faceStore = gs.faceStore;
    this.history = gs.history;
    this.editorStateStore = gs.editorStateStore;
  }

  private $history_addColumn(columnData: IColumnData, faceData: Partial<Record<EFaceSide, string>>) {
    this.history.startOperation();

    this.structStore.addColumnData(columnData);
    this.faceStore.refreshColumnFaceDadas();
    globalStores.faceStore
      .getColumnFaceDatas()
      .filter((face) => face.relativeInfo.columnId === columnData.id)
      .forEach((face) => {
        if (face.relativeInfo.columnSide !== undefined) {
          const materialId = faceData[face.relativeInfo.columnSide];
          if (materialId) {
            globalStores.faceStore.updateFaceMaterial(face.id, {
              id: materialId
            });
          }
        }
      });

    this.history.completeOperation(EOperationType.ColumnAdd);
  }

  private $history_delColumn(columnId: string) {
    this.history.startOperation();

    globalStores.structStore.removeColumnData(columnId);
    globalStores.faceStore.refreshColumnFaceDadas();

    this.history.completeOperation(EOperationType.ColumnDel);
  }

  private $history_modifyColumn(id: string, newColumnData: Partial<IColumnData>) {
    this.history.startOperation();

    globalStores.structStore.updateColumnData(id, newColumnData);
    globalStores.faceStore.refreshColumnFaceDadas();

    this.history.completeOperation(EOperationType.ColumnModify);
  }

  addColumn(columnData: IColumnData, faceData: Partial<Record<EFaceSide, string>>) {
    this.$history_addColumn(columnData, faceData);

    modelManager.structManager.updateEntity(columnData);
  }

  removeColumn(columnId: string) {
    this.$history_delColumn(columnId);
    modelManager.structManager.update();
    modelManager.selectedRerender();
  }

  modifyColumn(id: string, newColumnData: Partial<IColumnData>) {
    this.$history_modifyColumn(id, newColumnData);
    modelManager.structManager.updateEntity({ id });
  }

  copyColumn(columnId: string) {
    const columnData = this.structStore.getColumnData(columnId);
    if (!columnData) return;
    const faceSideMaterialMap = this.faceStore
      .getColumnFaceDatas()
      .filter((face) => face.relativeInfo.columnId === columnId)
      .reduce<Partial<Record<EFaceSide, string>>>((acc, { materialInfo: { id }, relativeInfo: { columnSide } }) => {
        if (columnSide !== undefined) {
          acc[columnSide] = id;
        }
        return acc;
      }, {});

    const copyColumnData = cloneDeep(columnData);
    copyColumnData.id = getUniqueId();
    this.editorStateStore.setVirtualColumnData(copyColumnData, faceSideMaterialMap);
    globalStores.operateInfo = {
      mode: EOperateMode.DrawStruct,
      toolType: copyColumnData.type === EColumnType.squareColumn ? EToolType.squareColumn : EToolType.cylinder,
      extraState: {
        copying: true
      }
    };

    globalStores.editorStateStore.setSelected({
      entityId: '',
      type: EEntityType.EMPTY
    });
  }
}
